import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AvatarMenu({ userEmail, credits, onSignOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const initial = (userEmail?.[0] ?? '?').toUpperCase();

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div ref={ref} style={s.wrap}>
      <button
        onClick={() => setOpen((v) => !v)}
        style={s.avatar}
        aria-label="Account menu"
        aria-expanded={open}
      >
        {initial}
      </button>
      {open && (
        <div style={s.panel}>
          <div style={s.email}>{userEmail}</div>
          <div style={s.divider} />
          <div style={s.credits}>{credits ?? 0} Credits Remaining</div>
          <div style={s.divider} />
          <MenuItem
            color="#c8d8f0"
            hoverBg="rgba(255,255,255,0.04)"
            onClick={() => { setOpen(false); navigate('/dashboard'); }}
          >
            My Documents
          </MenuItem>
          <MenuItem
            color="#6b9fff"
            hoverBg="rgba(45,95,196,0.08)"
            onClick={() => { setOpen(false); navigate('/get-credits'); }}
          >
            Get Credits
          </MenuItem>
          <MenuItem
            color="#c8d8f0"
            hoverBg="rgba(255,255,255,0.04)"
            onClick={() => { setOpen(false); navigate('/support'); }}
          >
            Support
          </MenuItem>
          <div style={s.divider} />
          <MenuItem
            color="#e05252"
            hoverBg="rgba(224,82,82,0.08)"
            onClick={() => { setOpen(false); onSignOut(); }}
          >
            Sign Out
          </MenuItem>
        </div>
      )}
    </div>
  );
}

function MenuItem({ children, color, hoverBg, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      style={{ ...s.item, color, background: hovered ? hoverBg : 'transparent' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

const s = {
  wrap: {
    position: 'relative',
    display: 'inline-flex',
  },
  avatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'rgba(45,95,196,0.2)',
    border: '0.5px solid rgba(107,159,255,0.3)',
    color: '#6b9fff',
    fontFamily: "'Outfit', sans-serif",
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: 0,
  },
  panel: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    background: '#0c1120',
    border: '0.5px solid rgba(255,255,255,0.07)',
    borderRadius: '10px',
    minWidth: '200px',
    padding: '8px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
    zIndex: 200,
  },
  email: {
    fontSize: '12px',
    color: '#6b82a8',
    padding: '8px 12px 12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  divider: {
    height: '0.5px',
    background: 'rgba(255,255,255,0.06)',
    margin: '0 -8px',
  },
  credits: {
    fontSize: '12px',
    color: '#6b9fff',
    padding: '8px 12px',
  },
  item: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    border: 'none',
    fontSize: '13px',
    padding: '10px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
    transition: 'background 0.1s',
  },
};
